module.exports = __webpack_public_path__ + "assets/images/project/album.svg?v=94d743e4";